import { render, staticRenderFns } from "./facebookInsightsLive.vue?vue&type=template&id=6bcffdfe&"
import script from "./facebookInsightsLive.vue?vue&type=script&lang=js&"
export * from "./facebookInsightsLive.vue?vue&type=script&lang=js&"
import style0 from "./facebookInsightsLive.vue?vue&type=style&index=0&id=6bcffdfe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports